import validate from "/home/vsts/work/1/s/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/vsts/work/1/s/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  access: () => import("/home/vsts/work/1/s/middleware/access.js"),
  auth: () => import("/home/vsts/work/1/s/middleware/auth.js"),
  login: () => import("/home/vsts/work/1/s/middleware/login.js")
}